<div class="row mb-5">
    <div class="col-lg-4 offset-lg-4 mb-4 mb-lg-0">
        <div class="card h-100">
            <div class="card-header">
                <h2 class="card-header-title">Thank you for your donation</h2>
            </div>
            <div class="card-body">
                <h3>If You'd Like To Donate To The Devs, Send ETH Here. Thank You For Your Support !</h3>
                <h2 class="card-address">{{ content }}</h2>
            </div>
            <div class="card-footer">
                <span class="block-link" (click)="copy()">Copy to clipboard</span>
                <span class="block-copy" *ngIf="isCopy">Copied!</span>
            </div>
        </div>
    </div>
</div>